<template>
  <b-table
    :fields="fieldsMaterial"
    :items="GET_MATERIALS_TABLE_ID.results"
    show-empty
    responsive
    hover
    :empty-text="$t('empty_text')"
    @row-clicked="$emit('row-selected', $event)"
  >
    <template #head()="props">
      <span>{{ $t(props.label) }}</span>
    </template>
    <template #cell(character)="{item}">
      {{ item.product.character }}
    </template>
    <template #cell(unity)="{item}">
      {{ item.product.unity }}
    </template>

    <template #cell(actions)="data">
      <div class="d-flex align-items-center">
        <b-button
          variant="outline-success"
          class="ml-50 mt-50 mb-50"
          size="sm"
          @click="$emit('on-click-pto', data.item)"
        >
          {{$t('write_off')}}
        </b-button>

        <b-button
          variant="outline-primary"
          class="ml-50 mt-50 mb-50"
          size="sm"
          @click="$emit('on-click-reset', data.item)"
        >
          {{$t('return')}}
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BButton, BTable } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BTable,
    BButton,
  },
  data: () => ({
    fieldsMaterial: [
      {
        label: '№',
        key: 'id',
      },
      {
        label: 'vid_material',
        key: 'value',
      },
      {
        label: 'reference.name',
        key: 'product',
        formatter: value => value.title,
      },
      {
        label: 'reference.units',
        key: 'unity',
      },
      {
        label: 'amount',
        key: 'remainder',
      },
      {
        label: 'actions',
        key: 'actions',
      },
    ],
  }),
  computed: {
    ...mapGetters('materials', ['GET_MATERIALS_TABLE_ID']),
  },
}
</script>

<style>

</style>
